import { render } from "./PublicNumber.vue?vue&type=template&id=4ef73416&scoped=true"
import script from "./PublicNumber.vue?vue&type=script&lang=js"
export * from "./PublicNumber.vue?vue&type=script&lang=js"

import "./PublicNumber.vue?vue&type=style&index=0&id=4ef73416&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef73416"]])

export default __exports__